<template>
  <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
      </div>
      <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template v-if="activationLoading">
                          <div class="text-muted text-center mb-3">
                            <h4>Ativando sua Conta</h4>
                            <p class="mb-1">Aguarde, sua conta está sendo ativada..</p>
                          </div>
                        </template>
                        <template v-else-if="activationError">
                          <div class="text-muted text-center mb-3">
                            <h4>Ativando sua Conta</h4>
                            <p class="mb-1">Houve um erro na tentativa de ativar sua conta. Contate o Administrador do site.</p>
                          </div>
                        </template>
                        <template v-else-if="activationCompleted">
                          <div class="text-muted text-center mb-3">
                                <h4>Conta Ativada</h4>
                                <p class="mb-1">Sua conta foi ativada com sucesso!</p>
                            </div>
                        </template>
                        <template>
                            <div class="text-center" v-if="activationCompleted">
                              <base-button type="primary" class="my-4">
                                  <router-link to="/login" class="text-white">
                                    Continuar
                                  </router-link>
                              </base-button>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';

export default {
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('signup', [
      'activationCompleted',
      'activationError',
      'activationLoading',
    ]),
  },
  methods: mapActions('signup', [
    'activateAccount',
    'clearActivationStatus',
  ]),
  created() {
    this.activateAccount(this.$route.params);
  },
  beforeRouteLeave(to, from, next) {
    this.clearActivationStatus();
    next();
  },
};
</script>
